import React, { useMemo } from "react"

import { useNavigate } from "react-router-dom"

import CommonTable from "components/Common/CommonTable"
// import ViewInvoice from "./ViewInvoice"
// import { axiosbaseurl } from "configure"

const InvoicesList = ({ table_data }) => {
    // const [viewShow, setViewShow] = useState(false);
    // const [invoiceData, setInvoiceData] = useState(null);
    // const [loading, setLoading] = useState(null);

    const navigate = useNavigate()

    // const handleViewInvoice = async (currInvoice) => {
    //     try {
    //         setLoading(currInvoice?.invoiceID)
    //         const response = await axiosbaseurl.get(`/xero/invoice/${currInvoice?.invoiceID}`);
    //         if (response.data.success) {
    //             setInvoiceData({
    //                 ...currInvoice,
    //                 services: response.data.data?.lineItems || []
    //             })
    //             setViewShow(true)
    //         }
    //     } catch (error) {
    //         console.log(error)
    //     } finally {
    //         setLoading(null)
    //     }
    // }


    // columns

    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <div> {cellProps.row.index + 1}</div>
                },
            },
            {
                Header: "Client Name",
                accessor: "clientName",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Invoice No.",
                accessor: "invoiceNumber",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Total Amount. (£)",
                accessor: "total",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Status",
        disableSort: true,
                accessor: "status",
                disableFilters: true,
                filterable: true,
                className: "text-center",
            },
            {
                Header: "Date",
                accessor: "date",
                disableFilters: true,
                filterable: true,
                className: "text-center",
            },
            {
                Header: "Due Date",
                accessor: "dueDate",
                disableFilters: true,
                filterable: true,
                className: " text-center",
            },
            {
                Header: "Action",
                disableFilters: true,
                disableSort: true,
                accessor: "view",
                className: "col-2 text-center",
                Cell: cellProps => {
                    // const isLoading = loading === cellProps.row.original.invoiceID ?
                    //     'circle-notch bx-spin' : 'eye';
                    return (
                        <>
                            <a
                                href={`${process.env.REACT_APP_API_URL}/xero/invoice/pdf/${cellProps.row.original.invoiceID}`}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-success bg-green btn-sm me-2"
                            >
                                <i className={`fas fa-download me-1`}></i> Download Invoice
                            </a>
                            {/* <button
                                disabled={isLoading === 'circle-notch bx-spin'}
                                onClick={() => handleViewInvoice(cellProps.row.original)}
                                className="btn btn-success bg-green btn-sm me-2"
                            >
                                <i className={`fas fa-${isLoading} me-1`}></i> View
                            </button> */}
                        </>
                    )
                },
            },
        ],
        []
    )

    // table data
    const data = useMemo(() => (table_data), [table_data])

    return (
        <>
            <CommonTable
                columns={columns}
                data={data}
                heading={"Invoices"}
            >

                <div>
                    <button onClick={() => navigate(-1)} className="btn btn-secondary bg-dark ms-3">
                        <i className="fas fa-arrow-left me-3"></i>
                        Back
                    </button>
                </div>

            </CommonTable>

            {/* <ViewInvoice show={viewShow} setShow={setViewShow} invoiceData={invoiceData} /> */}

        </>
    )
}

export default InvoicesList